import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {CardSimpleHeader} from "components/Cards/CardSimpleHeader";
import {CardDotWithDataVertical} from "components/Cards/CardDotWithData";
import {getTimeByTextLink} from "utils/Time";
import MenuTime from "components/Menu/TimeMenu";
import Skeleton from "react-loading-skeleton";
import {getAnalysisSolarCO2Savings} from "utils/Requests/Analysis";
import {getWeightCO2Format} from "utils/Formats";
import {isSolarPhotovoltaicByCaller } from "utils/Types";
import {MdCloudOff} from "react-icons/md";

const loaderSkeleton = <Skeleton width={100}/>

export function CardCO2Savings({...props}) {
    const {t} = useTranslation();
    //current object data
    const [configuration, setConfiguration] = useState({
        ...props,
        text: 'time.today',
        url: 'time.today',
        dates: null,
        value: loaderSkeleton,
        defaultValue: loaderSkeleton,
        isLoading: true
    });

    //first load
    useEffect(() => {
        // clean up controller --> prevent crash with async function
        let isMounted = true;
        //first load...
        if(!configuration.isLoading) { return }
        //set energy request
        const setCO2Data = (endpoint) => {
            //plant/analysis/solar/production/text
            getAnalysisSolarCO2Savings({...configuration, interval: endpoint}, (response) => {
                //prevent crash with async function
                if (!isMounted) return null;
                const val = isSolarPhotovoltaicByCaller(configuration)?response.total/1000:response.total;
                setConfiguration({...configuration, url: endpoint, isLoading: false, value: getWeightCO2Format(val)});
            }, () => {
                //prevent crash with async function
                if (!isMounted) return null;
                setConfiguration({...configuration, isLoading: false, value: 'Error...'});
            });
        } //call to load data
        setCO2Data(configuration.url);
        //prevent crash with async function
        return () => { isMounted = false; };
    }, [configuration]);

    return (
        <div className="card card-statistics">
            <CardSimpleHeader { ...configuration} title={t('plant.savings')}
                  rightComponent={ <MenuTime configuration={configuration} handler={setConfiguration} />}
            />
            <div className="card-body statistics-body">
                <CardDotWithDataVertical {...configuration} avatarClass={"avatar-lg"} colorClass='bg-light-success'
                                         icon={<MdCloudOff />} text={getTimeByTextLink(configuration)}
                                         number={configuration.value} />
            </div>
        </div>
    );
}